import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-tap-highlight-color: transparent;
    }
    html {
        font-size: 62.5%;
    }
    body {
        font-family: 'Poppins', sans-serif;
        font-size: 18px;
    }
    a {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.black};
    }
    ul,ol {
        list-style: none;
    }
    p {
        font-weight: 300;
        font-size: 1.4rem;

        @media (min-width: 1200px) {
            font-size: 1.6rem;
        }
    }

`

export default GlobalStyle
